import navigationService from '../../services/NavigationService';
import branchRuleReader from '../../store/readHelpers/BranchRuleReader';
import sessionReader from '../../store/readHelpers/SessionReader';
import settingsReader from '../../store/readHelpers/SettingsReader';

const footerSelector = {
    selectShouldRenderNavRow() {
        return settingsReader.showAssessmentTrack() && !branchRuleReader.hasBranchRules() && !sessionReader.isContextReadinessCheck();
    },

    selectIsLargeTest(currentSection, sections) {
        if (sections.length >= 20) {
            return true;
        }

        const totalQuestions = sections.reduce((a, b) => b.questions.length + a, 0);
        if (totalQuestions >= 40) {
            return true;
        }

        const currentSectionQuestionCount = sections.find(section => section.id === currentSection)?.questions.length;
        return currentSectionQuestionCount + sections.length >= 20;
    },

    selectIsNavigationAllowed() {
        return !sessionReader.isOneWayNavigationSupportedContext() || !settingsReader.isOneWayNavigationEnabled();
    },

    selectProps(state) {
        const {
            api,
            assessment,
            currentlyShown,
            itemFlag: {
                flaggedItems,
            },
            progress,
            response,
            settings,
            ui,
        } = state;

        return {
            api,
            assessment,
            currentlyShown,
            flaggedItems,
            isLargeTest: this.selectIsLargeTest(currentlyShown.sectionId, assessment.sections),
            isNavigationAllowed: this.selectIsNavigationAllowed(),
            progress,
            // Included to trigger re-rendering when response status changes, but not on each and every response update.
            responseStatus: response.status,
            settingValues: settings.values,
            shouldRenderNavRow: this.selectShouldRenderNavRow(),
            showFinalStepButton: navigationService.isFinalStepAvailable(),
            ui,
        };
    },
};

export default footerSelector;
